import React, { useState, useEffect } from 'react';
import TrendModal from '../components/TrendModal';
import { Toaster, toast } from 'sonner';

const Trends = () => {
    const [trends, setTrends] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedTrend, setSelectedTrend] = useState(null);

    useEffect(() => {
        const fetchTrends = async () => {
            try {
                const response = await fetch('/api/trends.php', { credentials: 'include' });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                if (data.success) {
                    setTrends(data.trends);
                } else {
                    throw new Error(data.message || 'Failed to fetch trends');
                }
            } catch (error) {
                setError(error.message);
                toast.error(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchTrends();
    }, []);

    const handleOpenModal = (trend) => {
        setSelectedTrend(trend);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setSelectedTrend(null);
        setIsModalOpen(false);
    };

    const handleSubmit = async (payload) => {
        try {
            const response = await fetch('/api/actions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    action: 'send-to-blog',
                    payload: payload
                })
            });
            const data = await response.json();
            if (data.success) {
                toast.success('✅ Trend dodany do kolejki bloga!');
                handleCloseModal();
            } else {
                throw new Error(data.message || 'Błąd wysyłki');
            }
        } catch (error) {
            toast.error('Błąd: ' + error.message);
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error && trends.length === 0) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="p-6">
            <Toaster richColors position="top-center" />
            <h1 className="text-2xl font-bold text-gray-900">📈 Google Trends</h1>
            <p className="text-sm text-gray-600 mt-1">Najpopularniejsze tematy w Polsce</p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
                {trends.map((trend, index) => (
                    <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-shadow overflow-hidden">
                        <div className="p-4">
                            <h3 className="text-lg font-bold text-gray-900 mb-3">
                                {trend.query}
                            </h3>
                            <div className="flex items-center justify-between text-sm">
                                <span>{trend.search_volume}</span>
                                <span className="text-green-500">{trend.increase_percentage}%</span>
                            </div>
                             <div className="mt-4">
                                <p className="text-xs font-semibold text-gray-500 mb-2">Powiązane frazy:</p>
                                <div className="flex flex-wrap gap-1">
                                    {trend.trend_breakdown.slice(0, 5).map((keyword, i) => (
                                        <span key={i} className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded">
                                            {keyword}
                                        </span>
                                    ))}
                                </div>
                            </div>
                            <button
                                onClick={() => handleOpenModal(trend)}
                                className="w-full mt-4 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors">
                                ➕ Dodaj do bloga
                            </button>
                        </div>
                    </div>
                ))}
            </div>
            {isModalOpen && <TrendModal trend={selectedTrend} onClose={handleCloseModal} onSubmit={handleSubmit} />}
        </div>
    );
};

export default Trends;
